import { Pipe, PipeTransform } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CustomerReservation } from '@shared/features/account/interfaces/account-api.interface';
import { addYears, differenceInYears } from 'date-fns';
import { LIME_MAIN } from '../../../shared/constants/shared.constants';
import { bookingSortingTypes } from '../../../constants/booking-sorting.constants';

@Pipe({
  name: 'bookingDetailsLink',
  standalone: false
})
export class BookingDetailsLinkPipe implements PipeTransform {
  transform(reservation: CustomerReservation, args: { type: string }): any {
    let checkOutDate = new Date().getTime() > addYears(new Date(reservation.departureAt), 1).getTime();
    let link: string;
    let queryParams: {};
    let pastYearsDiff = differenceInYears(new Date(reservation.departureAt), new Date());

    if (!checkOutDate && reservation.status !== bookingSortingTypes.canceled && pastYearsDiff >= -1) {
      queryParams = { reservationId: reservation.id, lastName: reservation.primaryGuestLastName, auth: true };
    }

    link =
      !checkOutDate && reservation.status !== bookingSortingTypes.canceled && pastYearsDiff >= -1
        ? LIME_MAIN.LIME_STAY_GUEST_HUB + `?${new HttpParams({ fromObject: queryParams })}`
        : '/account/bookings/details/' + reservation.id;

    return args.type === 'link' ? link : queryParams;
  }
}
